import { useAppDispatch, useAppSelector } from "../../../../store/hooks";
import { changeColorValue, changeNumberValue, replaceShape } from "../../../../store/model";
import { RootState } from "../../../../store/store";
import ColorInput from "../../../Palettes/Propertybar/input/colorInput";
import NumberInput from "../../../Palettes/Propertybar/input/numberInput";
import SelectInput from "../../../Palettes/Propertybar/input/selectInput";
import {
  getColorValue,
  getNumberValue,
} from "../shapeHelper/getSetProperties";
import ShapePalette from "../ShapePalette";
import { convertToPolyline } from "./Polygon";

export interface LineTypeOption {
  value: number,
  label: string
}
const PolygonProperyPalette = ({ polygon }: { polygon: PolygonShape }) => {
  const dispatch = useAppDispatch();
  const defaultLineTypeId = useAppSelector((state: RootState) => state.tool.currentLineTypeId)
  const lineTypes = useAppSelector((state: RootState) => state.tool.lineTypes)

  return (
    <ShapePalette shapeId={polygon.id}>
      <div className="property__element">
        <ColorInput
          properyDisplayName={"Stroke color"}
          currentValue={getColorValue(polygon, "stroke")()}
          setValue={(input: ColorValue) => {
            console.log(input);

            const actionPayload = {
              id: polygon.id,
              propertyValue: input,
              propertyName: "stroke",
            };
            dispatch(changeColorValue(actionPayload));
          }}
        />
      </div>
      <div className="property__element">
        <ColorInput
          properyDisplayName={"Fill color"}
          currentValue={getColorValue(polygon, "fill")()}
          setValue={(input: ColorValue) => {
            console.log(input);

            const actionPayload = {
              id: polygon.id,
              propertyValue: input,
              propertyName: "fill",
            };
            dispatch(changeColorValue(actionPayload));
          }}
        />
      </div>
      <div className="property__element">
        <NumberInput
          propertyDisplayName="Line weight"
          currentValue={getNumberValue(polygon, "strokeWidth")}
          setValue={(number) => {
            const payload = {
              id: polygon.id,
              propertyValue: number,
              propertyName: "strokeWidth",
            };
            dispatch(changeNumberValue(payload));
          }}
        ></NumberInput>
      </div>
      <div>
        <button onClick={ () => {
          dispatch(replaceShape(convertToPolyline(polygon)))
        }
        }>Convert to Polyline</button>
      </div>
      <div className="property__element">
        <SelectInput
          properyDisplayName="Line type"
          choiseList={lineTypes.map((i) => {
            return { label: i.name, value: i.id }
          })}
          currentValue={ //TODO setget
            polygon.dashID !== undefined ? {
              label: lineTypes.find(i => i.id === (polygon.dashID))?.name ?? "",
              value: polygon.dashID ?? defaultLineTypeId
            } : { label: "Not Found", value: 0 }

          }
          setValue={function (input): void {
            const payload = {
              id: polygon.id,
              propertyValue: input.value,
              propertyName: "dashID",
            };
            dispatch(changeNumberValue(payload))
          }}
        />
      </div>
    </ShapePalette>

  );
};


const createPropertyPalette = (polygon: GeometricShape) => {
  if (polygon.type === "polygon")
    return <PolygonProperyPalette polygon={polygon} />;
  throw new Error("not a polygon")
};

export default createPropertyPalette;
